import { AVX_Address, HopePepe_Contract_Address, USDC_Contract_Address, USDT_Contract_Address, WBTC_Contract_Address } from "./utilies/constant";
import avax from "./assets/avalanche.svg";
import usdt from "./assets/USDT.png";
import usdc from "./assets/usdc.png";
import Hopepepe from "./assets/logo.png";
import wbtc from "./assets/WBTC.png";


export const Tokens = [
    {
      symbol: "HOPEPEPE",
      img: Hopepepe,
      name: "HOPEPEPE Token",
      category: "DeFi",
      ContractAddress: HopePepe_Contract_Address,
      type:"Token"
    },
    {
      symbol: "AVAX",
      img: avax,
      name: "Avalanche",
      category: "DeFi",
      ContractAddress: AVX_Address,
      type:"native"

    },
    {
      symbol: "USDT",
      img: usdt,
      name: "USDT Token",
      category: "DeFi",
      ContractAddress: USDT_Contract_Address,
      type:"Token"

    },
    {
      symbol: "USDC",
      img: usdc,
      name: "USDC Token",
      category: "DeFi",
      ContractAddress: USDC_Contract_Address,
      type:"Token"

    },
    {
        symbol: "WBTC",
        img: wbtc,
        name: "WBTC Token",
        category: "DeFi",
        ContractAddress: WBTC_Contract_Address,
        type:"Token"

      },
  ];

 export const tokensImages = {
    HOPEPEPE: Hopepepe,
    AVAX: avax,
    USDT: usdt,
    USDC: usdc,
    WBTC: wbtc
  };